module.exports = __webpack_public_path__ + "img/magneto.31b4242c.svg";